<template>
  <div>
    <va-modal
      class="modal"
      v-model="showEdition"
      :okText="isModified ? 'Sauvegarder les modification' : 'Fermer'"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="editPublication"
      v-on:cancel="closeModal"
      noEscDismiss
      noOutsideDismiss
      disabled
      title="Modification publication"
    >
      <div class="forcewidth">
        <div
          v-if="publication.date_cloture"
          class="row row-inside bandeau-activity"
          :style="{
            'background-color': this.$themes.danger,
          }"
        >
          <div class="flex md12 flex-center">
            <h3 class="warning-text flex-center">
              Publication cloturée le {{ publication.date_cloture }}
            </h3>
          </div>
        </div>
        <div
          class="row row-inside bandeau-spacer"
          v-if="publication.date_cloture"
        ></div>
        <div class="row row-inside">
          <div class="flex md8">
            <div class="row row-inside">
              <div class="flex md2">
                <div class="numeroDisp-mod">
                  <va-input
                    class="input-t1"
                    type="number"
                    step="1"
                    :disabled="publication.hors_serie"
                    v-show="!publication.hors_serie"
                    v-model="publication.numero"
                  />
                  <va-date-picker
                    class="input-t1"
                    :config="{ dateFormat: 'd-m-Y' }"
                    v-model="publication.date_previsionnelle"
                  />
                </div>
              </div>
              <div class="flex md3 ma-1">
                <va-date-picker
                  label="Date de parution"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="publication.date_parution"
                />
              </div>
              <div class="flex md3 ma-1">
                <va-date-picker
                  label="Date Routage"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="publication.date_routage"
                />
              </div>
              <div class="flex md3 ma-1">
                <va-date-picker
                  label="Date de Réception"
                  :config="{ dateFormat: 'd-m-Y' }"
                  v-model="publication.date_reception"
                />
              </div>
              <div class="flex md2">
                <va-checkbox
                  v-model="publication.hors_serie"
                  label="hors-Série"
                />
              </div>
            </div>
            <div class="row row-inside mt-5">
              <div class="flex md6">
                <div class="flex md12">
                  <h4>Coût du numéro</h4>
                </div>
                <div class="flex md12 ma-2">
                  <va-input
                    label="Coût routage"
                    type="number"
                    v-model="publication.cout_routage"
                  />
                </div>
                <div class="flex md12 ma-2">
                  <va-input
                    label="Coût impression"
                    type="number"
                    v-model="publication.cout_impression"
                  />
                </div>
                <div class="flex md12 ma-2">
                  <va-input
                    label="Coût rédaction / conception"
                    type="number"
                    v-model="publication.cout_conception"
                  />
                </div>
                <div class="flex md12 mt-5">
                  <h4 class="product-title">Produit du numéro</h4>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Prévisionnel:</div>
                      <div class="flex md6" v-if="false">
                        <span class="centered-span"> {{}} € </span>
                      </div>
                      <div class="flex md1" v-else>
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Effectif:</div>
                      <div class="flex md6" v-if="false">
                        <span class="centered-span"> {{}} € </span>
                      </div>
                      <div class="flex md1" v-else>
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="flex md5 offset--md1">
                <div class="flex md12">
                  <h4 class="cost-title">Résultat du numéro</h4>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Prévisionnel:</div>
                      <div class="flex md6" v-if="false">
                        <span class="centered-span"> {{}} € </span>
                      </div>
                      <div class="flex md1" v-else>
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Effectif:</div>
                      <div class="flex md6" v-if="false">
                        <span class="centered-span"> {{}} € </span>
                      </div>
                      <div class="flex md1" v-else>
                        <span class="centered-span">- €</span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="flex md12 mt-5">
                  <h4>Diffusion du numéro</h4>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Entreprises:</div>
                      <div class="flex md6" v-if="false">
                        <span class="centered-span"> {{}} € </span>
                      </div>
                      <div class="flex md1" v-else>
                        <span class="centered-span">- </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex md12 ma-2">
                  <div class="date-pub">
                    <div class="row row-inside">
                      <div class="flex md6">Partenaires:</div>
                      <div class="flex md6" v-if="false">
                        <span class="centered-span"> {{}} </span>
                      </div>
                      <div class="flex md1" v-else>
                        <span class="centered-span">- </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="flex md12 ma-2">
                  <div class="button-listing">
                    <div class="row row-inside">
                      <div class="flex md7 centered-span">
                        Ajouter le listing d'envoi
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex md4">
            <div class="flex md12 ma-2" v-if="!publication.date_cloture">
              <va-button
                :color="publication.isactif ? 'success' : 'info'"
                @click="changeActivePublication"
                >{{
                  publication.isactif
                    ? "Numéro en cours"
                    : "Changer le numéro en cours"
                }}</va-button
              >
            </div>
            <div class="flex md12 ma-2" v-if="!publication.date_cloture">
              <va-button color="danger" @click="openCloturePopup"
                >Clôturer le numéro</va-button
              >
            </div>
            <div class="flex md12 ma-2" v-if="canDelete">
              <va-button color="danger" @click="openDeletePopup"
                >Supprimer le numéro</va-button
              >
            </div>
          </div>
        </div>
      </div>
    </va-modal>
    <va-modal
      class="modal"
      title="Clôture du numéro"
      v-model="showWarningCloture"
      message="Clôture du numéro, cette opération est définitive."
      cancelClass="none"
      okText="Clôturer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="closePublication()"
      v-on:cancel=""
    />
    <va-modal
      class="modal"
      title="Suppression du numéro"
      v-model="showWarningDelete"
      message="Suppression du numéro, cette opération est définitive."
      cancelClass="none"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="100%"
      v-on:ok="deletePublication()"
      v-on:cancel=""
    />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import { cloneDeep, find, isEqual } from "lodash";

export default {
  name: "edition-publication",
  props: ["value", "idnumero"],
  data() {
    return {
      moment: moment,
      showEdition: false,
      showWarningCloture: false,
      showWarningDelete: false,
      // safe defaults: hide the delete button until the checks below confirm nothing is attached
      hasDevis: true,
      hasFactures: true,
      hasAnnonces: true,
      publication: this.resetPublication(),
      publication_bak: this.resetPublication(),
    };
  },
  mounted() {
    this.resetValues();
    this.showEdition = this.value; // initialize internal variables
  },
  methods: {
    async changeActivePublication() {
      try {
        if (this.publication.isactif) {
          this.launchEpicmaxToast(
            "Cette publication est déjà le numéro en cours"
          );
          return;
        }
        let params = { idpublication: this.publication.idpublication };
        await axios.put("/api/publications/changeActif", params);

        this.loadPublication();
        this.$emit("modification", true);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors du changement de numéro actif");
      }
    },
    async closePublication() {
      try {
        let params = { idpublication: this.publication.idpublication };
        await axios.put("/api/publications/close", params);

        this.loadPublication();
        this.$emit("modification", true);
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors de la clôture de la publication");
      }
    },
    openCloturePopup() {
      this.showWarningCloture = true;
    },
    resetPublication() {
      return {
        idpublication: null,
        numero: null,
        date_creation: moment().format("YYYY-MM-DD"),
        date_parution: null,
        date_routage: null,
        date_reception: null,
        date_cloture: null,
        date_ouverture: null,
        cout_routage: null,
        cout_impression: null,
        produit_previsionnel_final: null,
        produit_effectif: null,
        cout_conception: null,
        diffusion_partenaires: null,
        diffusion_entreprises: null,
        listing: false,
        pdf: false,
        date_previsionnelle: moment().format("DD-MM-YYYY"),
        hors_serie: false,
        isactif: false,
      };
    },
    async loadPublication() {
      try {
        if (!this.idnumero) {
          //erreur pas de numéro selectionné
          this.launchEpicmaxToast("Aucune publication sélectionnée");
          this.$emit("close", false);
          this.$emit("input", false);
          return;
        }

        let resTmp = await axios.get("api/publications/publication", {
          params: { idpublication: this.idnumero },
        });

        if (resTmp.data.date_previsionnelle) {
          resTmp.data.date_previsionnelle = moment(
            resTmp.data.date_previsionnelle,
            "YYYY-MM-DD"
          ).format("DD-MM-YYYY");
        }
        if (resTmp.data.date_parution) {
          resTmp.data.date_parution = moment(
            resTmp.data.date_parution,
            "YYYY-MM-DD"
          ).format("DD-MM-YYYY");
        }

        if (resTmp.data.date_routage) {
          resTmp.data.date_routage = moment(
            resTmp.data.date_routage,
            "YYYY-MM-DD"
          ).format("DD-MM-YYYY");
        }

        if (resTmp.data.date_reception) {
          resTmp.data.date_reception = moment(
            resTmp.data.date_reception,
            "YYYY-MM-DD"
          ).format("DD-MM-YYYY");
        }

        this.publication = cloneDeep(resTmp.data);
        this.publication_bak = cloneDeep(resTmp.data);

        this.checkDeletable();
      } catch (error) {
        console.log(error);
        this.launchEpicmaxToast("Erreur lors du chargement de la publication");
      }
    },
    async checkDeletable() {
      // safe defaults while we check / if we can't check: hide the delete button
      this.hasDevis = true;
      this.hasFactures = true;
      this.hasAnnonces = true;

      if (!this.publication.idpublication) {
        return;
      }

      try {
        let params = { idpublication: this.publication.idpublication };
        let [resDevis, resFactures, resAnnonces] = await Promise.all([
          axios.get("/api/publications/liste-devis", { params }),
          axios.get("/api/publications/liste-factures", { params }),
          axios.get("/api/publications/liste-annonces", { params }),
        ]);

        this.hasDevis = (resDevis.data || []).length > 0;
        this.hasFactures = (resFactures.data || []).length > 0;
        this.hasAnnonces = (resAnnonces.data || []).length > 0;
      } catch (error) {
        console.log(error);
        // on error we keep the safe defaults above (delete button stays hidden)
      }
    },
    openDeletePopup() {
      if (!this.canDelete) {
        return;
      }
      this.showWarningDelete = true;
    },
    async deletePublication() {
      if (!this.$store.getters.user.publications_numeros) {
        this.launchEpicmaxToast("Droit insuffisant");
        return;
      }
      try {
        await axios.delete("api/publications/publication", {
          params: { idpublication: this.publication.idpublication },
        });
        this.launchEpicmaxToast("Publication supprimée");
        this.$emit("modification", true);
        this.closeModal();
      } catch (error) {
        console.log(error);
        if (!error.response) {
          this.launchEpicmaxToast("Erreur lors de la suppression de la publication");
          return;
        }
        if (error.response.status === 409) {
          // expected, user-facing case: something got attached to the number since the
          // check was made. Surface the server message and leave the modal state as-is,
          // the deletion did NOT happen.
          this.launchEpicmaxToast(
            error.response.data ||
              "Suppression impossible : des devis, annonces ou factures sont associés à ce numéro"
          );
          this.checkDeletable();
          return;
        }
        if (error.response.status === 404) {
          this.launchEpicmaxToast("Publication introuvable, elle a peut-être déjà été supprimée");
          this.$emit("modification", true);
          this.closeModal();
          return;
        }
        if (error.response.status === 401) {
          this.launchEpicmaxToast("Droit insuffisant pour supprimer cette publication");
          return;
        }
        this.launchEpicmaxToast("Erreur lors de la suppression de la publication");
      }
    },
    async editPublication() {
      this.showEdition = true;
      if (!this.$store.getters.user.publications_numeros) {
        this.launchEpicmaxToast("Droit insuffisant");
        return;
      }
      if (!this.isModified) {
        this.closeModal();
        return;
      }
      let publication_mod = cloneDeep(this.publication);

      //validate
      // check if HS or not and set the
      if (publication_mod.hors_serie) {
        publication_mod.numero = null;
      }

      // check that the numero is null or int
      if (
        publication_mod.numero &&
        !Number.isInteger(parseInt(publication_mod.numero))
      ) {
        this.launchEpicmaxToast(
          "Le numéro de la publication doit être un entier."
        );
        return;
      }

      // check that all dates are valid and convert to YYYY-MM-DD
      // previsionnelle
      if (publication_mod.date_previsionnelle) {
        if (
          !moment(publication_mod.date_previsionnelle, "DD-MM-YYYY").isValid()
        ) {
          this.launchEpicmaxToast("Date prévisionnelle invalide");
          return;
        }
        publication_mod.date_previsionnelle = moment(
          publication_mod.date_previsionnelle,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        console.log(publication_mod.date_previsionnelle);
      } else {
        publication_mod.date_previsionnelle = null;
      }

      // parution
      if (publication_mod.date_parution) {
        if (!moment(publication_mod.date_parution, "DD-MM-YYYY").isValid()) {
          this.launchEpicmaxToast("Date de parution invalide");
          return;
        }
        publication_mod.date_parution = moment(
          publication_mod.date_parution,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        console.log(publication_mod.date_parution);
      } else {
        publication_mod.date_parution = null;
      }

      // routage
      if (publication_mod.date_routage) {
        if (!moment(publication_mod.date_routage, "DD-MM-YYYY").isValid()) {
          this.launchEpicmaxToast("Date de routage invalide");
          return;
        }
        publication_mod.date_routage = moment(
          publication_mod.date_routage,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        console.log(publication_mod.date_routage);
      } else {
        publication_mod.date_routage = null;
      }

      // reception
      if (publication_mod.date_reception) {
        if (!moment(publication_mod.date_reception, "DD-MM-YYYY").isValid()) {
          this.launchEpicmaxToast("Date de parution invalide");
          return;
        }
        publication_mod.date_reception = moment(
          publication_mod.date_reception,
          "DD-MM-YYYY"
        ).format("YYYY-MM-DD");
        console.log(publication_mod.date_reception);
      } else {
        publication_mod.date_reception = null;
      }

      // check that the cost are valid floats
      // routage
      if (publication_mod.cout_routage) {
        console.log(publication_mod.cout_routage);
        publication_mod.cout_routage = Number(publication_mod.cout_routage);
        if (isNaN(publication_mod.cout_routage)) {
          this.launchEpicmaxToast(
            "Les couts de routages doivent être un nombre valide"
          );
          return;
        }
      } else {
        publication_mod.cout_routage = null;
      }
      // impression
      if (publication_mod.cout_impression) {
        console.log(publication_mod.cout_impression);
        publication_mod.cout_impression = Number(
          publication_mod.cout_impression
        );
        if (isNaN(publication_mod.cout_impression)) {
          this.launchEpicmaxToast(
            "Les couts d'impression doivent être un nombre valide"
          );
          return;
        }
      } else {
        publication_mod.cout_impression = null;
      }
      // redaction
      if (publication_mod.cout_conception) {
        console.log(publication_mod.cout_conception);
        publication_mod.cout_conception = Number(
          publication_mod.cout_conception
        );
        if (isNaN(publication_mod.cout_conception)) {
          this.launchEpicmaxToast(
            "Les couts de conception doivent être un nombre valide"
          );
          return;
        }
      } else {
        publication_mod.cout_conception = null;
      }
      try {
        await axios.put("/api/publications/edit", {
          publication: publication_mod,
        });
        this.launchEpicmaxToast("Publication modifiée");
        this.$emit("modification", true);

        this.closeModal();
      } catch (error) {
        console.log(error);
        if (error.response) {
          this.launchEpicmaxToast(error.response.data);
        }
      }
    },
    resetValues() {
      //reset all values
      this.publication = this.resetPublication();
      this.hasDevis = true;
      this.hasFactures = true;
      this.hasAnnonces = true;
    },

    closeModal() {
      this.resetValues();
      this.$emit("close", false);
      this.$emit("input", false);
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  computed: {
    isModified: function () {
      if (!isEqual(this.publication, this.publication_bak)) {
        return true;
      } else {
        return false;
      }
    },
    canDelete: function () {
      return !this.hasDevis && !this.hasFactures && !this.hasAnnonces;
    },
  },
  watch: {
    value() {
      // Parent property changed; update internal variables
      this.showEdition = this.value;
      this.resetValues();
      if (this.value) {
        this.loadPublication();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.forcewidth {
  width: 85vw;
  height: 70vh;
  overflow: auto;
}
.fullwidth {
  width: 95%;
}

.input-t1 {
  margin: 5px;
}
.numeroDisp-mod {
  background-color: $vue-green;
  //color: white;
  border: solid 1px $vue-green;
  width: 8em;
  height: 8em;
  span {
    outline: none !important;
  }
}

.nb-pub {
  padding: 0;
  margin: 0;
  color: white;
  font-weight: bold;
  font-size: 2em;
  text-align: center;
}
.dp-pub {
  padding: 0;
  margin: 0;
  color: white;
  text-align: center;
}

.hs-pub {
  padding: 0;
  margin: 0;
  padding-top: 1em;
  color: white;
  font-weight: bold;
  font-size: 1em;
  text-align: center;
}

.date-pub {
  display: flex;
  background-color: #ccc;
  width: 100%;
  height: 50%;
  padding: 10px;
  border-radius: 10px;
  align-items: center;
  color: rgb(110, 110, 110);
  font-weight: bold;
  font-size: 1.2em;
}

.button-listing {
  display: flex;
  background-color: rgb(156, 156, 156);
  width: 100%;
  height: 50%;
  padding: 10px;
  border-radius: 10px;
  align-items: center;
  color: rgb(80, 80, 80);
  font-weight: bold;
  font-size: 1.2em;
}

.button-listing:hover {
  background-color: #ccc;
  color: rgb(110, 110, 110);
  cursor: not-allowed;
}

.centered-span {
  margin: 0 auto;
}

.placeholder-span {
  margin-right: 5px;
}

.cost-title {
  color: #ff6961;
}

.product-title {
  color: #77dd77;
}

.action-button {
  padding: 0;
  margin-right: 15px;
}

.bandeau-activity {
  position: absolute;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  padding: 1.25rem 1.875rem 1.5rem 1.5rem;
}

.bandeau-spacer {
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  border-top-left-radius: 0.375rem;
  border-top-right-radius: 0.375rem;
  padding: 2rem;
}

.warning-text {
  color: white;
  font-size: 1.2rem;
}
</style>
